import React from 'react';
import { useTranslation } from 'react-i18next';

import { Plan, PlansCollapes } from '@/modules/payment';
import { plansDetailsCollapseList } from '@/modules/payment/subscription/logic';
import { IPayment } from '@/modules/payment/types';
import { Typography } from '@/shared/components/atoms';

const PlansExpanded: React.FC<{
  bundles: IPayment.IBundleSchema[];
}> = ({ bundles }) => {
  const { t } = useTranslation('payment');

  return (
    <div className='flex flex-col gap-24'>
      <Typography variant='h2' weight='semiBold' className='text-text-default'>
        {t('compare-plans')}
      </Typography>
      <div className='flex flex-col'>
        <div className='ml-auto flex w-3/4 '>
          {bundles?.map((bundle, idx) => (
            <Plan key={idx} bundle={bundle} showDescription={false} />
          ))}
        </div>
        {plansDetailsCollapseList.map((plan, idx) => (
          <PlansCollapes
            {...plan}
            key={idx}
            isLast={idx === plansDetailsCollapseList.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export { PlansExpanded };
